// this file exists because the existing stuff out there is either
// hugely bloated (looking at you clipboard.js), flash-based, or
// has zero test coverage (every dumb npm clipboard module out there).
//
// So, here we go, reinventing the wheel.

const domCopy = (text) => {
  var scrollY = window.scrollY;
  var textArea = document.createElement("textarea");
  // contenteditable must be true, readonly false to work on ios
  // https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
  textArea.contenteditable = true;
  textArea.readonly = false;

  textArea.value = text;
  textArea.style.height = "0px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  if (navigator.userAgent.match(/ipad|iphone/i)) {
    const range = document.createRange();
    range.selectNodeContents(textArea);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 999999);
  }
  let success = false;
  let err = null;
  try {
    success = document.execCommand("copy");
  } catch (e) {
    success = false;
    err = e;
  }
  document.body.removeChild(textArea);
  window.scrollTo(0, scrollY);
  return success ? Promise.resolve(text) : Promise.reject(err);
};

export const copyToClipboard = (string) => {
  if (window.Clipboard && window.Clipboard.writeText) {
    return window.Clipboard.writeText(string).catch(() => domCopy(string));
  } else {
    return domCopy(string);
  }
};
